import React                            from 'react';


import  "./Timestamp.scss";

var moment =  require('moment');


export interface TimestampProps {
  time:number;
}


export class Timestamp extends React.Component<TimestampProps> {
  constructor(props:TimestampProps) {
    super(props);
  }

  render() {
    const timeAgo = moment.unix(this.props.time / 1000).fromNow();
    return <div className="scc-Timestamp">
            {timeAgo}
            </div>
  }
}
